import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
import { LanguagesIcon, FileTextIcon, MicIcon, CheckCircleIcon, BriefcaseIcon } from 'lucide-react';
export function Services() {
  const navigate = useNavigate();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  const languageServices = [{
    icon: LanguagesIcon,
    title: 'Translation',
    description: 'Professional document translation with cultural accuracy and attention to detail'
  }, {
    icon: MicIcon,
    title: 'Interpretation',
    description: 'Real-time interpretation services for meetings, conferences, and events'
  }, {
    icon: FileTextIcon,
    title: 'Transcription',
    description: 'Accurate audio and video transcription in multiple languages'
  }, {
    icon: CheckCircleIcon,
    title: 'Proofreading',
    description: 'Expert editing and proofreading to ensure flawless communication'
  }];
  return <section id="services" className="py-24 bg-white" data-id="element-387">
      <div className="max-w-7xl mx-auto px-6" data-id="element-388">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 50
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-389">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-390">
            Professional <span className="text-green-600" data-id="element-391">Services</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-392">
            Beyond teaching, we offer comprehensive language services for
            individuals and businesses
          </p>
        </motion.div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-393">
          {/* Language Services */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} data-id="element-394">
            <h3 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-395">
              Language Services
            </h3>
            <div className="space-y-6" data-id="element-396">
              {languageServices.map((service, index) => <motion.div key={service.title} initial={{
              opacity: 0,
              y: 20
            }} animate={inView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="flex gap-4 p-6 rounded-xl bg-slate-50 hover:bg-green-50 transition-colors duration-300" data-id="element-397">
                  <div className="flex-shrink-0" data-id="element-398">
                    <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-399">
                      <service.icon className="text-white" size={24} data-id="element-400" />
                    </div>
                  </div>
                  <div data-id="element-401">
                    <h4 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-402">
                      {service.title}
                    </h4>
                    <p className="text-slate-600" data-id="element-403">{service.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
          {/* Corporate Training */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-10 text-white" data-id="element-404">
            <BriefcaseIcon className="w-16 h-16 text-orange-400 mb-6" data-id="element-405" />
            <h3 className="text-3xl font-bold mb-4" data-id="element-406">
              Corporate Bilingual Training
            </h3>
            <p className="text-slate-300 text-lg mb-8" data-id="element-407">
              Empower your team with customized language training programs
              designed to enhance communication, expand global reach, and drive
              business success.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-408">
              {['Customized curriculum for your industry', 'Flexible scheduling for busy professionals', 'On-site or virtual training options', 'Progress tracking and reporting', 'Certification preparation'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-409">
                  <CheckCircleIcon className="text-green-400 flex-shrink-0" size={20} data-id="element-410" />
                  <span className="text-slate-200" data-id="element-411">{item}</span>
                </li>)}
            </ul>
            <button onClick={() => navigate('/hire-us')} className="w-full bg-green-600 text-white py-4 rounded-full font-semibold hover:bg-green-700 transition-colors duration-200 text-lg" data-id="element-412">
              Hire Us
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}